module.exports = __webpack_public_path__ + "img/noData.7cd85733.png";